import React from 'react';

import { useFeatureFlags } from 'Utilities/hooks';
import { useReturningUser } from 'Utilities/hooks/useReturningUser';

import { BreakpointProvider } from '../../../../../components/misc/Breakpoints/Breakpoints';
import { RecommendedBy } from '../../../landingPages/Components/RecommendedBy/RecommendedBy';
import { CarPrizeDraw } from '../../Components/CarPrizeDraw/CarPrizeDraw';
import { GuidesSection as Guides } from '../../Components/GuidesSection/GuidesSection';
import { Hero as HomepageHero } from '../../Components/Hero/Hero';
import { HeroReturningUser } from '../../Components/Hero/HeroReturningUser';
import { HomepageFAQ } from '../../Components/HomepageFAQ/HomepageFAQ';
import { HowItWorks } from '../../Components/HowItWorks/HowItWorks';
import { NewsAndTools } from '../../Components/NewsAndTools/NewsAndTools';
import { Reviews } from '../../Components/Reviews/Reviews';
import { SellerStories } from '../../Components/SellerStories/SellerStories';
import { SocialProof } from '../../Components/SocialProof/SocialProof';

import { LogReturningUser } from './LogReturningUser';

import styles from './Homepage.scss';

const HomepageHeroContent = () => (
  useReturningUser() ? <HeroReturningUser /> : <HomepageHero />
);

const Homepage = () => {
  const { showCarPrizeDraw } = useFeatureFlags();

  return (
    <>
      <LogReturningUser />
      <BreakpointProvider>
        <HomepageHeroContent />
        {showCarPrizeDraw ? <CarPrizeDraw /> : null}
        <HowItWorks className={styles.howItWorks} />
        <SellerStories className={styles.sellerStories} />
        <SocialProof />
        <Reviews className={styles.reviews} />
        <RecommendedBy className={styles.partnerLogos} page="homepage" />
        <NewsAndTools className={styles.newsAndTools} />
        <HomepageFAQ className={styles.faq} />
        <Guides />
      </BreakpointProvider>
    </>
  );
};

export default Homepage;
